import React from 'react';
import PopUp from '../PopUp/PopUp';
import FilterSelect from '../Select/FilterSelect';
import Button from '../Button/Button';
import { DeletePopupWrapper, DivContainer, RadioContainer } from './FilterPopup.styled';
import { useSelector } from 'react-redux';

const FilterPopup = ({
  handleClosePopup,
  setSelectedOption,
  selectedOption,
  filterOption,
  handleFilterChange,
  openDropdown,
  setOpenDropdown,
  view,
  setView,
  handleCancel,
  handleApply,
  handleClear
}) => {
    const { personalDetailsData } =
      useSelector((state) => state.tenantSetting) || {};
  
  let col=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(180deg, #2d8955 0%, #5eab41 100%)'
  return (
    <PopUp onClose={handleClosePopup}>
      <DeletePopupWrapper>
        <p>Customize View</p>
        <DivContainer>
          <FilterSelect
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
            option={filterOption}
            options={[
              'Bar Graph',
              'Donut Chart',
              'Pie Chart',
              'Funnel Chart',
            ]}
            onChange={(selectedOption) => handleFilterChange(selectedOption)}
            placeholder='Visual View'

            data-testid="fliters"
            dropdownId="fliters"
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
          {
            filterOption == 'Bar Graph' &&
            <RadioContainer>
              <label>
                <input
                  type='radio'
                  name='viewType'
                  data-testid="horizontal"
                  value='horizontal'
                  checked={view == 'horizontal' ? true : false}

                // checked={view === 'horizontal'}
                  onChange={(e) => setView(e.target.value)}
                />
                Horizontal View
              </label>
              <label>
                <input
                  type='radio'
                  name='viewType'
                  data-testid="vertical"
                  value='vertical'
                // checked={view === 'vertical'}
                  checked={view == 'vertical' ? true : false}

                  onChange={(e) => setView(e.target.value)}
                />
                Vertical View
              </label>
            </RadioContainer>
          }

        </DivContainer>
        <div>
          <Button value={'Cancel'} style={{background:'transparent'}} onClick={() => handleCancel()} />
          <Button value={'Clear All'} style={{background:'transparent',color:'#2d8955',border:'1px solid #2d8955'}} onClick={handleClear} />
          <Button value={'Apply'} onClick={handleApply} style={{background:col ? col : 'rgba(45, 137, 85, 1)'}} />
        </div>
      </DeletePopupWrapper>
    </PopUp>
  );
};


export default FilterPopup;